module.exports = __webpack_public_path__ + "img/alfie-m6.193e8931.jpeg";